<script lang="ts" setup>
import { cn } from '@/utils';

interface LoadingScreenProps {
	/**
	 * Custom classes for the loading icon
	 */
	iconClasses?: string;
	/**
	 * Custom classes for the container
	 */
	containerClasses?: string;
}

withDefaults(defineProps<LoadingScreenProps>(), {
	iconClasses: 'h-8 w-8 text-primary',
	containerClasses: ''
});
</script>

<template>
	<div
		:class="
			cn('flex h-full w-full items-center justify-center', containerClasses)
		"
	>
		<IconPilarCircularProgress :class="cn('animate-spin', iconClasses)" />
	</div>
</template>
